import Yup from 'utils/validation';
import { businessFormInitialValues } from '../utils';
import { validDDDs } from 'utils/basicUtils';

export const transportsInitialValues = {
  ...businessFormInitialValues,
};

export const transportsValidationSchema = Yup.object().shape({
  id: Yup.number(),
  businessOwner: Yup.array().of(
    Yup.string()
      .required()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0)
  ),
  businessRepresentative: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value =>
      Array.isArray(value) ? value.every(item => item?.trim().length > 0) : value?.trim().length > 0
    ),
  businessType: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value =>
      Array.isArray(value) ? value.every(item => item?.trim().length > 0) : value?.trim().length > 0
    ),
  description: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value =>
      Array.isArray(value) ? value.every(item => item?.trim().length > 0) : value?.trim().length > 0
    ),
  document: Yup.string()
    .notRequired()
    .test('not-empty', 'Campo não pode ser apenas espaços', value => !value || value.trim().length > 0),
  experiences: Yup.array().of(Yup.string()).required(),
  googleMapsLink: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
  tradeEmail: Yup.string().lowercase().notRequired(),
  tradeName: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
  title: Yup.string()
    .required()
    .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
  phone: Yup.string()
    .notRequired()
    .test('not-empty', 'Campo não pode ser apenas espaços', value => !value || value.trim().length > 0),
  site: Yup.string().url('Link do site inválido'),
  youtubeLink: Yup.string().url('Link do Youtube inválido'),
  instagramLink: Yup.string().url('Link do Instagram inválido'),
  facebookLink: Yup.string().url('Link do Facebook inválido'),
  whatsapp: Yup.string(),
  image: Yup.array().min(1).required(),
  address: Yup.object().shape({
    id: Yup.number(),
    additionalData: Yup.string(),
    city: Yup.string()
      .required()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
    neighborhood: Yup.string()
      .matches(/^(?!^\d+$)[\d\D]*$/, 'O bairro não pode conter somente números')
      .required()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
    number: Yup.string().matches(/^\d*$/, 'O campo número deve conter apenas números').required(),
    state: Yup.string()
      .required()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
    street: Yup.string()
      .matches(/^(?!\d+$).*/, 'O campo endereço não pode ser apenas números')
      .required()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => value?.trim().length > 0),
    zipCode: Yup.string()
      .notRequired()
      .test('not-empty', 'Campo não pode ser apenas espaços', value => !value || value.trim().length > 0),
  }),
  images: Yup.array().min(1).required(),
});
